import { engineComponent, StringUtils, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { StageController } from "../Components/StageController";
import { ITweenable, Tweens, TweensAttributes } from "../Components/Effects/Tweens";
import { Attributes } from "../Utils/Attributes";
import { ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";
import { CustomUtils } from "../Utils/CustomUtils";

/**
 * FilterElement class is class which create filter and applicate it on other element
 * !!! Attribute "Image" for filter must by "power-of-two" size !!!
 * @class FilterElement
 * @extends BaseElement
 */

@engineComponent(ComponentTypes.DisplayObject)
export class FilterElement extends BaseElement {
    public sprite: PIXI.Sprite;
    private texture: PIXI.Texture;
    public filter: string;
    public filtersTemp: any;
    private blendMode: number;
    private image: string;
    private repeat: boolean;
    private count: number;
    public parent: any;
    // public filters: Array <any>;

    private _created: boolean;

    constructor() {
        super();

        this.count = 0;
        this._created = false;
    }

    public create(node: Element, parent?: any): void {
        this.parent = parent;
        this.createByNode(node);
        this.updateByNode(node);
    }

    public createByNode(node: Element): void {
        if (!this._created) {
            super.createByNode(node);

            if (node.hasAttribute(FilterElementAttributes.BLEND_MODE)) {
                this.blendMode = CustomUtils.getBlendMode(
                    parseInt(node.getAttribute(FilterElementAttributes.BLEND_MODE)),
                );
            }

            if (node.hasAttribute(FilterElementAttributes.IMAGE)) {
                this.image = node.getAttribute(FilterElementAttributes.IMAGE);
            }

            if (node.hasAttribute(FilterElementAttributes.FILTER)) {
                this.filter = node.getAttribute(FilterElementAttributes.FILTER);
            }

            if (node.hasAttribute(FilterElementAttributes.REPEAT)) {
                this.repeat = StringUtils.parseBoolean(node.getAttribute(FilterElementAttributes.REPEAT));
            }

            this.createFilter();

            this._created = true;
        }
    }

    /**
     *
     * @param {Element} node
     */
    public updateByNode(node: Element): void {
        if (this._created) {
            super.updateByNode(node);

            // this.runPositionTween(node);
            this.runTween(node);

            // Tweens.removeTweens(this, 'displacement');

            // this.sprite.renderable = true

            // let tweenDuration = 60 / this._animationStyle.speed;
            // let tl = Tweens.customTween(this, {
            //     tween: 'displacement',
            //     tweenValues: [0, 0],
            //     tweenDuration: [120],
            //     tweenEase: ['linear'],
            //     tweenLoop: true,
            //     callbackType: 'onUpdate',
            //     callbackFunction: this.updateTexture,
            //     callbackScope: this,
            //     // callbackParams: [this.filtersTemp, displacementSprite]
            // });
        }
    }

    private updateTexture(): void {
        this.sprite.position.x = this.count * 20;
        this.sprite.position.y = -this.count * 20;
        this.count += 0.05;
        // displacementSprite.y = count*10;

        this.parent.filters = [this.filtersTemp];
    }

    /**
     *
     */
    private createFilter(): void {
        if (this.image != null && this.filter != null) {
            this.texture = StageController.getTextureByResourceId(this.image);
            this.sprite = new PIXI.Sprite(this.texture);
        }

        // this.sprite.scale.x = 1.33;
        // this.sprite.scale.y = 1.33;
        if (this.repeat != null && this.repeat == true) {
            this.sprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
        }

        if (this.filter != null && this.sprite != null) {
            switch (this.filter) {
                case "Displacement":
                    this.filtersTemp = new PIXI.filters.DisplacementFilter(this.sprite);
                    break;
            }
        }

        // let tween: ITweenable = <any> this.sprite
        // Tweens.positionTween(tween, {
        //     tweenX:[0,512],
        //     tweenY:[0,512],
        //     tweenEase:null,
        //     tweenDuration:300,
        //     tweenDelay:0,
        //     tweenLoop:true}
        // );
    }

    /**
     *
     * @param {Element} node
     * @returns {boolean}
     */
    public runTween(node: Element): boolean {
        if (node.hasAttribute(TweensAttributes.TWEEN)) {
            let tweens: Array<string> = ArrayUtils.stringArray(node.getAttribute(TweensAttributes.TWEEN));

            for (let i: number = 0; i < tweens.length; i++) {
                //return if there are no values to tween
                if (!node.hasAttribute(TweensAttributes.TWEEN_VALUES + i)) {
                    return false;
                }

                let tween: string = tweens[i];

                const tweenValues: Array<number> = this.formatTweenValues(
                    tween,
                    ArrayUtils.stringArray(node.getAttribute(TweensAttributes.TWEEN_VALUES + i)),
                );
                const tweenDuration: Array<number> = ArrayUtils.numberArray(
                    node.getAttribute(TweensAttributes.TWEEN_DURATION + i) || "120",
                );
                const tweenEase: Array<string> = ArrayUtils.stringArray(
                    node.getAttribute(TweensAttributes.TWEEN_EASE + i) || "linear",
                );
                const tweenDelay: Array<number> = ArrayUtils.numberArray(
                    node.getAttribute(TweensAttributes.TWEEN_DELAY + i) || "0",
                );
                const tweenLoop: boolean = Attributes.assignBooleanAttribute(
                    node,
                    TweensAttributes.TWEEN_LOOP + i,
                    null,
                );

                if (tween === "scale") {
                    tween = "scale.x";
                    tweens[i] = "scale.y";
                    i--;
                }

                let tweenObject: ITweenable = <any>this.sprite;

                Tweens.customTween(tweenObject, {
                    tween,
                    tweenValues,
                    tweenEase,
                    tweenDuration,
                    tweenDelay,
                    tweenLoop,
                });
            }
        }

        return false;
    }

    /**
     * Runs the position tween
     * @method runPositionTween
     * @param node
     * @returns {boolean}
     */
    public runPositionTween(node: Element): boolean {
        if (
            (!node.hasAttribute(ImageElementAttributes.POSITION_TWEEN_X) ||
                !node.hasAttribute(ImageElementAttributes.POSITION_TWEEN_Y)) &&
            (!node.hasAttribute("PositionTweenToX") || !node.hasAttribute("PositionTweenToY")) &&
            (!node.hasAttribute("AbsolutePositionTweenToX") || !node.hasAttribute("AbsolutePositionTweenToY"))
        ) {
            return false;
        }

        let positionTweenX: Array<number>;
        let positionTweenY: Array<number>;

        if (
            node.hasAttribute(ImageElementAttributes.POSITION_TWEEN_X) &&
            node.hasAttribute(ImageElementAttributes.POSITION_TWEEN_Y)
        ) {
            let positionTweenPosition: string = Attributes.assignStringAttribute(
                node,
                ImageElementAttributes.POSITION_TWEEN_POSITION,
                null,
            );
            if (positionTweenPosition === ImageElementAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
                positionTweenX = ArrayUtils.numberArray(node.getAttribute(ImageElementAttributes.POSITION_TWEEN_X)).map(
                    (value) => value + this.position.x,
                );
                positionTweenY = ArrayUtils.numberArray(node.getAttribute(ImageElementAttributes.POSITION_TWEEN_Y)).map(
                    (value) => value + this.position.y,
                );
            } else {
                positionTweenX = ArrayUtils.numberArray(node.getAttribute(ImageElementAttributes.POSITION_TWEEN_X));
                positionTweenY = ArrayUtils.numberArray(node.getAttribute(ImageElementAttributes.POSITION_TWEEN_Y));
            }
        } else if (node.hasAttribute("PositionTweenToX") && node.hasAttribute("PositionTweenToY")) {
            positionTweenX = ArrayUtils.numberArray(node.getAttribute("PositionTweenToX"));
            positionTweenX.unshift(this.position.x);

            positionTweenY = ArrayUtils.numberArray(node.getAttribute("PositionTweenToY"));
            positionTweenY.unshift(this.position.y);
        } else if (node.hasAttribute("AbsolutePositionTweenToX") && node.hasAttribute("AbsolutePositionTweenToY")) {
            positionTweenX = ArrayUtils.numberArray(node.getAttribute("AbsolutePositionTweenToX")).map(
                (value) => this.position.x + (value - this.getGlobalPosition().x),
            );
            positionTweenX.unshift(this.position.x);

            positionTweenY = ArrayUtils.numberArray(node.getAttribute("AbsolutePositionTweenToY")).map(
                (value) => this.position.y + (value - this.getGlobalPosition().y),
            );
            positionTweenY.unshift(this.position.y);
        }

        const tweenX: Array<number> = positionTweenX || [];
        const tweenY: Array<number> = positionTweenY || [];
        const tweenEase: string = Attributes.assignStringAttribute(
            node,
            ImageElementAttributes.POSITION_TWEEN_EASE,
            null,
        );
        const tweenDuration: number = Attributes.assignIntAttribute(
            node,
            ImageElementAttributes.POSITION_TWEEN_DURATION,
            120,
        );
        const tweenDelay: number = Attributes.assignIntAttribute(node, ImageElementAttributes.POSITION_TWEEN_DELAY, 0);
        const tweenLoop: boolean = Attributes.assignBooleanAttribute(
            node,
            ImageElementAttributes.POSITION_TWEEN_LOOP,
            null,
        );

        Tweens.positionTween(this, { tweenX, tweenY, tweenEase, tweenDuration, tweenDelay, tweenLoop });
    }

    /**
     *
     * @returns {FilterElement}
     */
    clone(): FilterElement {
        let element: FilterElement = new FilterElement();

        element._created = this._created;
        element.visible = this.visible;
        element.alpha = this.alpha;
        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;

        element.blendMode = this.blendMode;
        element.image = this.image;
        element.filter = this.filter;
        element.repeat = this.repeat;
        element.texture = this.texture;
        element.sprite = this.sprite;
        element.filtersTemp = this.filtersTemp;

        element.parent.addChild(this.sprite);
        element.parent.filters = [this.filtersTemp];

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

const FilterElementAttributes = {
    /**
     * Blend mode of mesh object.
     * @property BlendMode
     * @default 0
     */
    BLEND_MODE: "BlendMode",
    /**
     * Bezier curviness.
     * @default 1
     */
    CURVINESS: "Curviness",
    REPEAT: "Repeat",
    FILTER: "Filter",
    /**
     * Start animation in random frame.
     * @default false
     */
    RANDOM_START_FRAME: "RandomStartFrame",
    /**
     * Start time of the first animation loop. Automatically set RandomStartFrame to false.
     * @default false
     */
    TIME: "Time",
    /**
     * Global points, pairs of X,Y coords for mesh.
     * @property Points
     * @default null
     */
    GLOBAL_POINTS: "GlobalPoints",
    /**
     * Reference to image from resources.
     * @property Image
     * @default 0
     */
    IMAGE: "Image",
    /**
     * Play animation
     * @property Play
     * @default false
     */
    PLAY: "Play",
    /**
     * If true, animation will not be stopped and restarted, when PLAY is fired
     * @property Play
     * @default false
     */
    CONTINUE: "Continue",
    /**
     * Points, pairs of X,Y coords for mesh.
     * @property Points
     * @default null
     */
    POINTS: "Points",
    /**
     * Number of X,Y points for mesh. Higher make mesh detailed.
     * @property PointsCount
     * @default 100
     */
    POINTS_COUNT: "PointsCount",
    /**
     * Reverse collected input points.
     */
    REVERSE_POINTS: "ReversePoints",
    /**
     * Stop animation
     * @property Play
     * @default false
     */
    STOP: "Stop",
    /**
     * Tint of image. Hex color which colorize movie clip.
     * @property Tint
     * @default null
     */
    TINT: "Tint",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/FilterElement.ts
 **/